import rpc from '@square/dashboard-utilities/clients/rpc';
import { FeedbackSurveysExternalService } from '@square/dashboard-protos/models/squareup/feedbacksurveys/service';
export default FeedbackSurveysExternalService.create(rpc());